// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { login } from '../utils/api';
// import { useAuth } from '../context/AuthContext';
// import toast from 'react-hot-toast';

// export default function LoginPage() {
//   const [form, setForm] = useState({ email: '', password: '' });
//   const [loading, setLoading] = useState(false);
//   const [showPass, setShowPass] = useState(false);
//   const { loginUser } = useAuth();
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.email || !form.password) { toast.error('Fill in all fields'); return; }
//     setLoading(true);
//     try {
//       const res = await login(form);
//       loginUser(res.data.token, res.data.user);
//       toast.success(`Welcome back, ${res.data.user.name}!`);
//       navigate('/');
//     } catch (err) {
//       toast.error(err.response?.data?.message || 'Login failed');
//     } finally { setLoading(false); }
//   };

//   return (
//     <div className="min-h-screen bg-surface-900 flex items-center justify-center px-4">
//       <div className="w-full max-w-sm">
//         {/* Logo */}
//         <div className="text-center mb-8">
//           <div className="w-12 h-12 bg-brand-400/20 border border-brand-400/30 rounded-xl flex items-center justify-center mx-auto mb-4">
//             <span className="text-brand-400 text-2xl">◈</span>
//           </div>
//           <h1 className="font-display text-xl font-semibold text-surface-100">Admin Panel</h1>
//           <p className="text-surface-500 text-sm mt-1">DesignCraft Interiors</p>
//         </div>

//         <div className="card p-6">
//           <h2 className="text-surface-200 font-semibold mb-5">Sign in to your account</h2>
//           <form onSubmit={handleSubmit} className="space-y-4">
//             <div>
//               <label className="label">Email Address</label>
//               <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
//                 className="input" placeholder="admin@company.com" autoComplete="email" />
//             </div>
//             <div>
//               <label className="label">Password</label>
//               <div className="relative">
//                 <input type={showPass ? 'text' : 'password'} value={form.password}
//                   onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
//                   className="input pr-10" placeholder="••••••••" autoComplete="current-password" />
//                 <button type="button" onClick={() => setShowPass(p => !p)}
//                   className="absolute right-3 top-1/2 -translate-y-1/2 text-surface-500 hover:text-surface-300 text-xs">
//                   {showPass ? 'Hide' : 'Show'}
//                 </button>
//               </div>
//             </div>
//             <button type="submit" disabled={loading} className="btn-primary w-full py-2.5 mt-2">
//               {loading ? 'Signing in...' : 'Sign In'}
//             </button>
//           </form>
//         </div>

//         <p className="text-center text-surface-600 text-xs mt-6">
//           Default: admin@company.com / Admin@123456
//         </p>
//       </div>
//     </div>
//   );
// }


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff, Lock, Mail, Loader, Shield } from 'lucide-react';
import { login } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.email) errs.email = 'Required';
    if (!form.password) errs.password = 'Required';
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setLoading(true);
    try {
      const res = await login(form);
      loginUser(res.data.token, res.data.user);
      toast.success(`Welcome back, ${res.data.user.name}!`);
      navigate('/');
    } catch (err) {
  console.log("FULL ERROR:", err.response?.data); // 👈 ye add karo

  const msg = err.response?.data?.message || 'Invalid credentials';
  toast.error(msg);
  setErrors({ password: msg });
} finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-900 p-4">
      {/* Background pattern */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-primary-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-primary-500/10 border border-primary-500/20 rounded-2xl mb-4">
            <Shield size={24} className="text-primary-400" />
          </div>
          <h1 className="text-2xl font-semibold text-white">Admin Panel</h1>
          <p className="text-white/40 text-sm mt-1">Majestic Wood Crafts</p>
        </div>

        <div className="card p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="label">Email Address</label>
              <div className="relative">
                <Mail size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
                <input
                  type="email"
                  value={form.email}
                  onChange={e => { setForm(f => ({ ...f, email: e.target.value })); setErrors(errs => ({ ...errs, email: '' })); }}
                  placeholder="admin@portfolio.com"
                  className={`input pl-9 ${errors.email ? 'border-red-500/50' : ''}`}
                />
              </div>
              {errors.email && <p className="text-red-400 text-xs mt-1">{errors.email}</p>}
            </div>

            <div>
              <label className="label">Password</label>
              <div className="relative">
                <Lock size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
                <input
                  type={showPass ? 'text' : 'password'}
                  value={form.password}
                  onChange={e => { setForm(f => ({ ...f, password: e.target.value })); setErrors(errs => ({ ...errs, password: '' })); }}
                  placeholder="••••••••"
                  className={`input pl-9 pr-10 ${errors.password ? 'border-red-500/50' : ''}`}
                />
                <button type="button" onClick={() => setShowPass(!showPass)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/30 hover:text-white/60">
                  {showPass ? <EyeOff size={15} /> : <Eye size={15} />}
                </button>
              </div>
              {errors.password && <p className="text-red-400 text-xs mt-1">{errors.password}</p>}
            </div>

            <button type="submit" disabled={loading} className="btn-primary w-full justify-center py-2.5 mt-2">
              {loading ? <><Loader size={14} className="animate-spin" /> Signing in...</> : 'Sign In'}
            </button>
          </form>

          {/* <div className="mt-4 p-3 bg-surface-700 rounded-lg">
            <p className="text-white/30 text-xs text-center font-mono">
              Default: admin@portfolio.com / Admin@123
            </p>
          </div> */}
        </div>
      </div>
    </div>
  );
}